import { Link } from 'react-router-dom'
import { useRef, useEffect, useState } from 'react'
import styles from './SubcategoryDropdown.module.scss'

type SubcategoryDropdownProps = {
  category: any
  isOpen: boolean
  onClose: () => void
  onMouseEnter: () => void
  parentRef?: any
}

const SubcategoryDropdown = ({ category, isOpen, onClose, onMouseEnter, parentRef }: SubcategoryDropdownProps) => {
  const [leftOffset, setLeftOffset] = useState(0)

  useEffect(() => {
    if (isOpen && parentRef?.current) {
      const rect = parentRef.current.getBoundingClientRect()
      setLeftOffset(rect.left)
    }
  }, [isOpen, parentRef])

  if (!isOpen || !category?.children || category.children.length === 0) return null

  return (
    <div
      className={`${styles.dropdown} ${isOpen ? styles.open : ''}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onClose}
    >
      <div className={styles.content} style={{ paddingLeft: `${leftOffset}px` }}>
        {category.children.map((subcategory: any) => (
          <Link
            key={subcategory.id}
            to={`/products?categoryId=${subcategory.id}&parent_id=${category.id}`}
            className={styles.subcategoryItem}
            onClick={onClose}
          >
            {subcategory.name}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default SubcategoryDropdown
